<template>
  <a-modal
    :title="title"
    width="40%"
    :visible="visible"
    :confirm-loading="confirmLoading"
    :maskClosable="false"
    :keyboard="false"
    @cancel="handleCancel"
    @ok="submit"
    ok-text="保存"
    cancel-text="取消"
    :destroyOnClose="true"
  >
    <div>
      <a-form-model
        ref="ruleForm"
        :model="form"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item label="年份" prop="addYear">
          <a-date-picker
            placeholder="请选择年份"
            v-model="form.addYear"
            :open="yearShowOne"
            :locale="locale"
            :format="'YYYY'"
            mode="year"
            @openChange="openChangeOne"
            @panelChange="panelChangeOne"
            @change="handleClearAcquireYear"
            style="width: 100%"
            :disabled="disabeld"
          />
        </a-form-model-item>
        <a-form-model-item label="发文数量" prop="publicationNum">
          <a-input-number
            v-model="form.publicationNum"
            min="1"
            precision="0"
            @blur="blurValue"
            style="width: 100%"
            placeholder="请输入发文数量"
            :disabled="disabeld"
          />
        </a-form-model-item>
        <a-form-model-item label="点击量" prop="clickNum">
          <a-input-number
            v-model="form.clickNum"
            min="1"
            precision="0"
            @blur="blurValue"
            style="width: 100%"
            placeholder="请输入点击量"
            :disabled="disabeld"
          /> </a-form-model-item
        ><a-form-model-item label="关注人数" prop="focusNum">
          <a-input-number
            v-model="form.focusNum"
            min="1"
            precision="0"
            @blur="blurValue"
            style="width: 100%"
            placeholder="请输入关注人数"
            :disabled="disabeld"
          /> </a-form-model-item
        ><a-form-model-item label="微课开发" prop="smallCourseNum">
          <a-input-number
            v-model="form.smallCourseNum"
            min="1"
            precision="0"
            @blur="blurValue"
            style="width: 100%"
            placeholder="请输入微课开发"
            :disabled="disabeld"
          />
        </a-form-model-item>
        <a-form-model-item label="院校交流学习次数" prop="collegesStudentNum">
          <a-input-number
            v-model="form.collegesStudentNum"
            min="1"
            precision="0"
            @blur="blurValue"
            style="width: 100%"
            placeholder="请输入院校交流学习次数"
            :disabled="disabeld"
          />
        </a-form-model-item>

        <a-form-model-item label="宣传渠道载体" prop="channelCarriers">
          <a-select
            placeholder="请选择宣传渠道载体"
            style="width: 100%"
            mode="multiple"
            @change="addExpertChange"
            v-model="form.channelCarriers"
            :disabled="disabeld"
          >
            <a-select-option
              v-for="item in xcList"
              :key="item.text"
              :value="item.text"
            >
              {{ item.text }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
      </a-form-model>
    </div>
  </a-modal>
</template>

<script>
import { getAction, postAction, putAction } from "@/api/index";
import zh_CN from "ant-design-vue/lib/locale-provider/zh_CN";
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
import moment from "moment";
import "moment/locale/zh-cn";
import BaseEditor from "@/components/common/BaseEditor.vue";
moment.locale("zh-cn");
export default {
  data() {
    return {
      visible: false,
      confirmLoading: false,
      labelCol: { span: 6 },
      wrapperCol: { span: 15 },
      other: "",
      form: {
        applyId: "",
        addYear: "",
        publicationNum: "",
        clickNum: "",
        focusNum: "",
        smallCourseNum: "",
        collegesStudentNum: "",
        channelCarriers: [],
        channelCarrier: "",
      },
      rules: {
        addYear: [
          {
            required: true,
            message: "请选择年份",
            validator: (rule, value, callback) => {
              if (this.form.addYear != "") {
                callback(); // 验证通过
              } else {
                callback(new Error("请选择年份"));
              }
            },
            trigger: "change",
          },
        ],
        publicationNum: [
          {
            required: true,
            message: "请输入发文数量",
            trigger: "blur",
          },
        ],
        clickNum: [
          {
            required: true,
            message: "请输入点击量",
            trigger: "blur",
          },
        ],
        focusNum: [
          {
            required: true,
            message: "请输入关注人数",
            trigger: "blur",
          },
        ],
        smallCourseNum: [
          {
            required: true,
            message: "请输入微课开发",
            trigger: "blur",
          },
        ],
        collegesStudentNum: [
          {
            required: true,
            message: "请输入院校交流学习次数",
            trigger: "blur",
          },
        ],
        channelCarriers: [
          {
            required: true,
            message: "请选择宣传渠道载体",
            trigger: "change",
          },
        ],
      },
      yearShowOne: false,
      zh_CN,
      locale,
      applyType: 2,
      // 添加还是编辑
      type: "",
      // 弹框标题
      title: "",
      xwlist: [],
      jblist: [],
      kclist: [],
      ishow: false,
      ifirst: true,
      disabeld: false,
      xcList: [],
    };
  },
  components: { BaseEditor },
  // 在组件的data部分之外添加
  watch: {
    "form.channelCarriers": {
      handler(newVal, oldVal) {
        console.log("channelCarriers changed:", oldVal, "->", newVal);
      },
      deep: true,
    },
  },
  mounted() {
    console.log("111111");
    console.log(this.rules);
  },
  methods: {
    getxclist() {
      getAction("/baseCommon/getDictItemsByCode?code=channel_carrier").then(
        (res) => {
          if (res.code == 200) {
            console.log(res, "4444");
            this.xcList = res.result;
          }
        }
      );
    },
    addExpertChange() {
      console.log(this.form.channelCarriers, "channelCarriers"); // 打印结果['宣传栏']0: "宣传栏"length: 1[[Prototype]]: Array(0) 'channelCarriers'
      // 多个选择器的值用逗号隔开
      if (this.form.channelCarriers.length > 0) {
        this.form.channelCarrier = this.form.channelCarriers.join(",");
      } else {
        this.form.channelCarrier = "";
      }
    },
    blurValue() {
      if (this.form.amount == "1") {
        this.ifirst = true;
      } else {
        this.ifirst = false;
        this.form.content = "";
      }
    },
    handleChange() {
      console.log(this.form.achievementType);
      if (this.form.achievementType == "SZKC") {
        this.ishow = true;
      } else {
        this.ishow = false;
        this.form.courseType = "";
      }
    },
    openChangeOne(status) {
      if (status) {
        this.yearShowOne = true;
      }
    },
    handleClearAcquireYear() {
      //  	console.log("111111");
      this.form.addYear = ""; // 或者适当的空值，根据你的业务需求
      this.$forceUpdate();
    },
    panelChangeOne(value) {
      //   	      console.log(value,"111111");
      const year = moment(value).format("YYYY");
      this.form.addYear = year + "";
      this.yearShowOne = false;
      // this.form.addYear = value;
      this.$refs.ruleForm.clearValidate("addYear");
      // this.yearShowOne = false;
    },
    init(type, record) {
      this.type = type;
      this.visible = true;
      this.getxclist();

      if (type == "add") {
        // 不要完全替换 form 对象，而是逐个重置属性
        this.form.applyId = record.id || "";
        this.form.addYear = new Date().getFullYear() + "";
        this.form.publicationNum = null;
        this.form.clickNum = null;
        this.form.focusNum = null;
        this.form.smallCourseNum = null;
        this.form.collegesStudentNum = null;
        this.form.channelCarriers = []; // 重置为数组
        this.form.channelCarrier = "";

        this.title = "新增品牌宣传";
      } else if (type == "edit") {
        // 逐个赋值，保持响应式
        this.form.addYear = record.addYear;
        this.form.publicationNum = record.publicationNum;
        this.form.clickNum = record.clickNum;
        this.form.focusNum = record.focusNum;
        this.form.smallCourseNum = record.smallCourseNum;
        this.form.collegesStudentNum = record.collegesStudentNum;
        this.form.applyId = record.applyId;
        this.form.id = record.id;
        this.form.channelCarriers = record.channelCarrier
          ? record.channelCarrier
              .split(",")
              .filter((item) => item.trim() !== "")
          : [];
        console.log("record.channelCarrier", record);
        console.log(" this.form.channelCarriers", this.form.channelCarriers);
        this.title = "编辑品牌宣传";
      } else {
        // 查看模式
        this.form.addYear = record.addYear;
        this.form.publicationNum = record.publicationNum;
        this.form.clickNum = record.clickNum;
        this.form.focusNum = record.focusNum;
        this.form.smallCourseNum = record.smallCourseNum;
        this.form.collegesStudentNum = record.collegesStudentNum;
        this.form.applyId = record.applyId;
        this.form.id = record.id;
        this.form.channelCarrier = record.channelCarrier;
        this.form.channelCarriers = record.channelCarrier
          ? record.channelCarrier
              .split(",")
              .filter((item) => item.trim() !== "")
          : [];

        this.disabeld = true;
        this.title = "查看品牌宣传";
      }

      console.log("初始化后的表单数据:", this.form);
      console.log("channelCarriers:", this.form.channelCarriers);
      console.log("channelCarrier:", this.form.channelCarrier);
    },
    handleCancel() {
      this.visible = false;
      // this.yearShowOne = false;
    },
    submit() {
      // 清空之前的验证
      this.$refs.ruleForm.clearValidate();

      // 处理年份数据
      if (
        typeof this.form.addYear == "object" &&
        this.form.addYear != "" &&
        this.type == "add"
      ) {
        this.form.addYear = new Date(this.form.addYear).getFullYear() + "";
      }

      // 验证表单
      this.$refs.ruleForm.validate((valid) => {
        console.log("表单验证结果:", valid);

        // 验证失败，直接返回，不触发任何事件
        if (!valid) {
          console.log("表单验证失败，请检查输入");
          return false;
        }

        // 验证成功，准备数据
        let params = { ...this.form };

        // 处理年份格式
        if (typeof params.addYear == "object" && params.addYear != "") {
          params.addYear = new Date(params.addYear).getFullYear() + "";
        }

        // 设置应用类型
        params.applyType = this.applyType;

        // 处理渠道载体
        if (this.form.channelCarriers && this.form.channelCarriers.length > 0) {
          params.channelCarrier = this.form.channelCarriers.join(",");
        }

        console.log("准备提交的数据:", params);

        // 根据类型触发不同的事件
        if (this.type == "add") {
          // 新增模式
          this.visible = false;
          this.$message.success("添加成功");
          this.$emit("addPropaganda", { record: params, type: "add" });
        } else if (this.type == "edit") {
          // 编辑模式
          this.visible = false;
          this.$message.success("编辑成功");
          this.$emit("addPropaganda", { record: params, type: "edit" });
        }

        // 注意：查看模式不应该触发保存事件
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .ant-modal-title {
  text-align: center;
}
/deep/ .ant-input-number-handler-wrap {
  display: none;
}
.ipt-other {
  margin-left: 12px;
}
</style>
